import "./Form.css"

import React from 'react'

function FormInput() {
  return (
    <div>FormInput</div>
  )
}

export default FormInput